import { Modal } from "react-bootstrap"



const ConfirmDeleteModal = ({isOpen, setIsOpen, onConfirm}) => {
    return (
        <Modal show={isOpen} onHide={() => setIsOpen(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to delete this image?
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={() => setIsOpen(false)}>Cancel</button>
                <button className="btn btn-danger" onClick={() => {
                    onConfirm()
                    setIsOpen(false)
                }}>Delete</button>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmDeleteModal